// extracted by mini-css-extract-plugin
export default {"tabsNews":"index_tabsNews_D-WVM","tabs":"index_tabs_bBUa-","itis":"index_itis_WDRIY"};